import { object, string, number, setLocale } from 'yup'

setLocale({
  mixed: {
    default: 'common.required',
    notType: 'common.required',
    required: 'common.required'
  },
  number: {
    lessThan: 'common.required',
    max: 'common.required',
    min: 'common.required',
    moreThan: 'common.required'
  }
})

export default object().shape({
  access_code: string().when(['agreement_type', 'integration_type'], {
    is: (agreement_type, integration_type) =>
      agreement_type === 'AIR' || integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  // agreement_id: string().trim().required(),
  agreement_type: string().trim().required(),
  branch_id: string().when('integration_type', {
    is: integration_type => integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  code: string().notRequired(),
  domain: string().when(['agreement_type', 'integration_type'], {
    is: (agreement_type, integration_type) =>
      agreement_type === 'AIR' || integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  fee_value: number().positive('').required(),
  gtw_agency_id: string().when(['agreement_type', 'integration_type'], {
    is: (agreement_type, integration_type) =>
      agreement_type !== 'AIR' || integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  gtw_group_id: string().when(['agreement_type', 'integration_type'], {
    is: (agreement_type, integration_type) =>
      agreement_type !== 'AIR' || integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  integration_type: string().trim().required(),
  package_group: string().when(['agreement_type', 'integration_type'], {
    is: (agreement_type, integration_type) =>
      agreement_type !== 'AIR' || integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  password: string().when('integration_type', {
    is: integration_type => integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  service_hub_id: number().min(0).required(),
  username: string().when('integration_type', {
    is: integration_type => integration_type === 'PARTNER',
    then: string().notRequired(),
    otherwise: string().required()
  })
})
